/* 15.10.2026 (user): widgety Judge.me po polsku tam, gdzie panel nie daje zmiany:
   data opinii 21/08/2026 -> 21.08.2026 (lista formatow w panelu bez kropek), zakladki i etykiety "recenzje" -> "opinie",
   ukryte "Thumbnail Navigation", "N reviews" w plakietce. Zamiana na wezlach tekstowych w .jdgm-widget,
   MutationObserver dla tresci dociaganej przez Judge.me (po zamianie wzorzec juz nie pasuje, wiec bez petli). */
(function () {
  function liczba(n) {
    var d = n % 10, s = n % 100;
    if (n === 1) return 'opinia';
    if (d >= 2 && d <= 4 && (s < 12 || s > 14)) return 'opinie';
    return 'opinii';
  }
  var ZAMIANY = [
    [/^(\s*)(\d{2})\/(\d{2})\/(\d{4})(\s*)$/, '$1$2.$3.$4$5'],
    [/Recenzje produktów i sklepu/, 'Opinie o produktach i sklepie'],
    [/Recenzje sklepu/, 'Opinie o sklepie'],
    [/Recenzja sklepu/, 'Opinia o sklepie'],
    [/^(\s*)Recenzja dla(\s*)$/, '$1Opinia o produkcie:$2'],
    [/Załaduj więcej recenzji/, 'Pokaż więcej opinii'],
    [/Zobacz wszystkie recenzje/, 'Zobacz wszystkie opinie'],
    [/^(\s*)Thumbnail Navigation(\s*)$/, '$1Nawigacja miniatur$2'],
    [/^(\s*)(\d+) reviews?(\s*)$/, function (m, a, n, b) { return a + n + ' ' + liczba(parseInt(n, 10)) + b; }]
  ];
  function popraw(wezel) {
    var t = wezel.nodeValue;
    if (!t || !t.trim()) return;
    var nowy = t;
    for (var i = 0; i < ZAMIANY.length; i++) nowy = nowy.replace(ZAMIANY[i][0], ZAMIANY[i][1]);
    if (nowy !== t) wezel.nodeValue = nowy;
  }
  function skanuj(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) popraw(n);
  }
  function wszystkie() {
    document.querySelectorAll('.jdgm-widget').forEach(skanuj);
  }
  var czeka = false;
  function dotyczy(m) {
    var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (el && el.closest && el.closest('.jdgm-widget')) return true;
    for (var i = 0; i < m.addedNodes.length; i++) {
      var a = m.addedNodes[i];
      if (a.nodeType === 1 && (a.matches('.jdgm-widget') || a.querySelector('.jdgm-widget'))) return true;
    }
    return false;
  }
  var obs = new MutationObserver(function (lista) {
    if (czeka || !lista.some(dotyczy)) return;
    czeka = true;
    requestAnimationFrame(function () { czeka = false; wszystkie(); });
  });
  function start() {
    wszystkie();
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
